export default __webpack_public_path__ + "static/media/01_gallery_NB-H3801_rotisserie.a69808b5.jpg";